export default __webpack_public_path__ + "static/shepherd-d747d3b458aede0cb377da0fdea3a798.png";